import { apiClient } from './client'

export interface PoolInfo {
  max: number
  active: number
}

export interface WorkerStats {
  max_tasks: number
  active: number
  available: number
  pools: {
    pipeline: PoolInfo
    creation: PoolInfo
    other: PoolInfo
  }
}

export interface QueueStats {
  total: number
  by_status: Record<string, number>
  worker: WorkerStats
}

export interface MonitorPipeline {
  id: string
  pipeline_type: string
  title: string
  status: string
  progress: number
  current_step: string | null
  step_index: number | null
  total_steps: number | null
  error_message: string | null
  created_at: string
  updated_at: string
  started_at: string | null
  step_started_at: string | null
  progress_config?: Array<{ step: string; index: number; progress: number; duration_sec?: number }>
}

export interface MonitorCreationTask {
  id: string
  module_type: string
  creation_type: string
  title: string
  status: string
  progress: number
  expected_output_count: number
  succeeded_output_count: number
  error_code: string | null
  error_message: string | null
  model_name: string
  provider: string
  created_at: string
  updated_at: string
  started_at: string | null
}

export interface MonitorCommand {
  id: string
  name: string
  app: string
  status: string
  args: Record<string, unknown>
  error_message: string | null
  created_at: string
  updated_at: string
  started_at: string | null
  completed_at: string | null
  attempts: number
}

export interface TaskSystemMonitor {
  queue: QueueStats
  pipelines: {
    items: MonitorPipeline[]
    by_status: Record<string, number>
  }
  creation_tasks: {
    items: MonitorCreationTask[]
    by_status: Record<string, number>
  }
  recent_commands: MonitorCommand[]
}

export const taskMonitorApi = {
  /** Single source of truth for all task data. */
  getTaskSystemStatus: async () => {
    const response = await apiClient.get<TaskSystemMonitor>(
      '/agent-api/creation/monitor/task-system',
    )
    return response.data
  },
}